/**
 * Converts a number to a percentage string without modifying the decimal places.
 * For example, 12 becomes "12%".
 *
 * @param number - A numeric value to format as a percentage.
 * @returns A string representing the number followed by a percent sign.
 */
export const toPercentageString = (number: number): `${number}%` => {
  return `${number}%`;
};

/**
 * Converts a number to a percentage string with exactly two decimal places,
 * unless it's a whole number. Truncates extra decimals beyond the second.
 *
 * Examples:
 *  - 12 => "12%"
 *  - 12.1 => "12.10%"
 *  - 12.12 => "12.12%"
 *  - 12.123 => "12.12%"
 *
 * @param value - A numeric value to format as a percentage with precision.
 * @returns A percentage string with consistent formatting.
 */
export const toFixedDecimalPercentage = (value: number): string => {
  // Handle float precision errors by rounding to 2 decimal places first
  const rounded = Math.round(value * 100) / 100;
  return (rounded % 1 === 0 ? rounded.toString() : rounded.toFixed(2)) + '%';
};

// GM%-axis peer of getNormalizedPriceInMicros: snap to 1-decimal display
// precision so two margins that render identically compare equal.
export const getNormalizedGrossMarginPercentage = (
  grossMarginPercentage: number,
): number => Number(grossMarginPercentage.toFixed(1));
